import Loader from './loader';
/**
 * Nunjucks client-side templates handler
 */
class Template {
    constructor() {
        this.loader_ = Loader;
        this.baseUrl_ = '';
        this.libFile = 'vendor/nunjucks-slim.min.js';
        this.libLoaded = false;
        this.hasLoaded = {
            lib: false,
            templates: []
        };
        this.renderQueue_ = [];
    }
    /**
     * This must be called before any `render()` calls
     * To avoid race condition between runtime file and template files, we have a `renderQueue_`
     */
    setUrl(url, loader = this.loader_) {
        this.baseUrl_ = url;
        if (!this.libLoaded) {
            const libUrl = `${this.baseUrl_}/${this.libFile}`;
            loader.loadJS(libUrl, () => {
                this.libLoaded = true;
                // Process any queued render operation that are called before runtime is loaded
                this.processQueue_();
            });
        }
    }
    processQueue_() {
        while (this.renderQueue_.length > 0) {
            const q = this.renderQueue_.shift();
            if (typeof q === 'function') {
                q();
            }
        }
    }
    render(modName, tplName, data, loader = this.loader_) {
        // if base url is not set, throw error
        if (!this.baseUrl_) {
            throw new Error('Base URL for Nunjucks runtime is not set!');
        }
        const tplFullName = this.getFullTemplateName(modName, tplName);
        return new Promise((resolve, reject) => {
            const r = () => {
                this.loadTemplate_(tplFullName, () => {
                    resolve(this.render_(tplFullName, data));
                }, reject, loader);
            };
            if (this.libLoaded) {
                r();
            }
            else {
                this.renderQueue_.push(r);
            }
        });
    }
    loadTemplate_(tplFullName, cb, errCb, loader = this.loader_) {
        const filePath = `${this.baseUrl_}/js/templates/${tplFullName}.js`;
        loader.loadJS(filePath, () => {
            this.hasLoaded.templates.push(tplFullName);
            cb();
        }, errCb);
    }
    render_(name, data) {
        if (window.nunjucks) {
            return window.nunjucks.render(name, data);
        }
        else {
            return '';
        }
    }
    getFullTemplateName(modName, tplName) {
        return `mod-${modName}/templates/${tplName}.njk`;
    }
}
const template = new Template();
export default template;
